import React from 'react';
import OriginalThreeDimensionViewpoint from '../components/OriginalThreeDimensionViewpoint';

export default function ViewpointPage() {
  return (
    <div style={{
      width: '100%',
      height: 'calc(100vh - 120px)', // Full viewport height minus nav/footer
      backgroundColor: '#0a0a0a',
      overflow: 'hidden',
    }}>
      <OriginalThreeDimensionViewpoint fullScreen={true} />
    </div>
  );
}
